import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

interface TipoPagamento {
  id: number;
  descricao: string;
}

@Component({
  selector: 'app-tipo-pagamento',
  templateUrl: './tipo-pagamento.component.html',
  styleUrls: ['./tipo-pagamento.component.scss']
})
export class TipoPagamentoComponent implements OnInit {
  descricao = '';
  filtroDescricao = '';
  itens: TipoPagamento[] = [];
  itensFiltrados: TipoPagamento[] = [];
  itensPaginados: TipoPagamento[] = [];
  itemEdicao: TipoPagamento | null = null;
  modalRef: NgbModalRef | null = null;

  loading = false;
  paginaAtual = 1;
  itensPorPagina = 10;

  constructor(
    private modalService: NgbModal,
    private ajaxService: AjaxService,
    private util: UtilService
  ) {}

  ngOnInit(): void {
    this.carregar();
  }

  get totalPaginas(): number {
    return Math.ceil(this.itensFiltrados.length / this.itensPorPagina) || 1;
  }

  carregar(): void {
    this.loading = true;
    this.util.showLoading();
    this.ajaxService.get(`${API}financeiro/TipoPagamento/Consultar`).subscribe({
      next: (response) => {
        this.loading = false;
        this.util.closeLoading();
        const lista = Array.isArray(response?.data) ? response.data : [];
        this.itens = lista.map((x: any) => {
          const item = this.util.converterParaLowercase(x || {});
          return {
            id: Number(item.id || 0),
            descricao: String(item.descricao || '').trim()
          } as TipoPagamento;
        }).filter((x: TipoPagamento) => x.id > 0);
        this.aplicarFiltros();
      },
      error: () => {
        this.loading = false;
        this.util.closeLoading();
        this.itens = [];
        this.itensFiltrados = [];
        this.itensPaginados = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar os tipos de pagamento.');
      }
    });
  }

  abrirModalCadastro(content: TemplateRef<any>, item?: TipoPagamento): void {
    this.itemEdicao = item || null;
    this.descricao = item?.descricao || '';
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  salvar(): void {
    const descricao = String(this.descricao || '').trim();
    if (descricao.length < 2) {
      this.util.toasterShowError('Atenção', 'Informe uma descrição válida.');
      return;
    }

    const payload = { id: this.itemEdicao?.id || 0, descricao };

    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/TipoPagamento/Salvar`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', this.itemEdicao ? 'Registro atualizado com sucesso!' : 'Registro criado com sucesso!');
        this.modalRef?.close();
        this.itemEdicao = null;
        this.descricao = '';
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar tipo de pagamento.');
      }
    });
  }

  deletar(item: TipoPagamento): void {
    if (!confirm(`Tem certeza que deseja excluir o tipo de pagamento "${item.descricao}"?`)) {
      return;
    }

    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/TipoPagamento/Deletar`, { id: item.id }).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível excluir.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', 'Registro excluído com sucesso!');
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao excluir tipo de pagamento.');
      }
    });
  }

  aplicarFiltros(): void {
    const termo = String(this.filtroDescricao || '').toLowerCase().trim();
    this.itensFiltrados = this.itens.filter(x => !termo || x.descricao.toLowerCase().includes(termo));
    this.paginaAtual = 1;
    this.atualizarPaginacao();
  }

  limparFiltros(): void {
    this.filtroDescricao = '';
    this.aplicarFiltros();
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.paginaAtual--;
      this.atualizarPaginacao();
    }
  }

  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.paginaAtual++;
      this.atualizarPaginacao();
    }
  }

  alterarItensPorPagina(): void {
    this.paginaAtual = 1;
    this.atualizarPaginacao();
  }

  private atualizarPaginacao(): void {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    this.itensPaginados = this.itensFiltrados.slice(inicio, inicio + this.itensPorPagina);
  }
}
